var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"watchVideo",staticClass:"watch-video"},[_c('shaka'),_c('controls',{attrs:{"canReturn":_vm.canReturn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }